import { CoreErrorDetails } from '../error-handler.backend-types'
import { TFunction } from 'i18next'

export function getResourceNotAvailableMessage(t: TFunction, formatDate: (date: Date) => string, details?: CoreErrorDetails<'RESOURCE_NOT_AVAILABLE'>): string | null {
  if (!details?.date) {
    return null
  }

  const message = t('pms.core_error.resource_not_available', { date: formatDate(new Date(details.date)) })

  return message
}
